import { render, staticRenderFns } from "./writeOffCenter.vue?vue&type=template&id=65534c20&scoped=true&"
import script from "./writeOffCenter.vue?vue&type=script&lang=js&"
export * from "./writeOffCenter.vue?vue&type=script&lang=js&"
import style0 from "./writeOffCenter.vue?vue&type=style&index=0&id=65534c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65534c20",
  null
  
)

component.options.__file = "writeOffCenter.vue"
export default component.exports